import styled from 'styled-components';

export const InputWrapper = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  padding: 8px 0;

  transition: all 0.2s ease-in-out;

  :hover {
    border-color: ${({ theme }) => theme.colors.green6};
  }

  :focus-within {
    border-color: ${({ theme }) => theme.colors.green6};
    box-shadow: 0px 0px 1px 2px ${({ theme }) => theme.colors.green2};
  }
`;

export const PreviewWrapper = styled.div`
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  padding: 8px 12px;
  flex-wrap: wrap;
  min-height: 116px;

  .katex {
    font-size: 14px;
  }

  p {
    margin: 0;
  }
`;
